import { useInvoiceEditorForm } from '../../../../../../../../../../../../../../contexts/invoiceEditorFormContext'
import { CurrencyInput } from '../../../../../../../../../CurrencyInput'
import { CommonInvoiceLineFieldProps } from '../../../../../../types/commonInvoiceLineFieldProps'

type InvoiceLineTotalExcludingVatProps = CommonInvoiceLineFieldProps

export const InvoiceLineTotalExcludingVat = ({ disabled = false, lineIndex }: InvoiceLineTotalExcludingVatProps) => {
  const { invoiceEditorForm } = useInvoiceEditorForm()
  const { FormItem } = invoiceEditorForm

  return (
    <FormItem
      name={`invoiceLines.${lineIndex}.totalExcludingVat`}
      render={({ field: { value, onChange, ...props } }) => {
        return <CurrencyInput {...props} disabled={disabled} onChange={onChange} readOnly value={value} size="sm" />
      }}
    />
  )
}
